<template>
  <div class="content" v-if="modelValue">
    <h2 class="title">
      <awesomeIcon icon="level-up-alt" style="transform:rotate(90deg);" />
      Financiële situatie
      {{modelValue.voorletters}}
      {{modelValue.tussenvoegsel}}
      {{modelValue.achternaam}}
    </h2>

    <p class="subheader" v-if="index==0">Wat is uw primaire inkomsten bron?</p>
    <p class="subheader" v-else>Wat is de primaire inkomsten bron van deze persoon?</p>
    <div class="flex-container flex-grow">
      <customInput
        v-model="modelValue.inkomenType"
        type="dropdown" label="Type inkomen"
        @changed="setWorkSituation"
        :options="[
          {label:'Loondienst', value:'Loondienst'},
          {label:'Zelfstandige (eenmanszaak)', value:'Eenmanszaak'},
          {label:'Zelfstandige (overige)', value:'Zelfstandige'},
          {label:'Pensioen / AOW', value:'Pensioen'},
          {label:'Uitkering', value:'Uitkering'},
          {label:'Werkzoekende', value:'Werkzoekende'},
          {label:'Anders', value:'Anders'},
          {label:'Geen', value:'Geen'},
        ]"
      />
      <customInput
        v-model="modelValue.jaarinkomen" type="money"
        label="Bruto-jaarinkomen"
        v-if="modelValue.inkomenType != 'Geen' && modelValue.inkomenType != 'Pensioen'"
      />
      <customInput
        v-model="modelValue.pensioen" type="money"
        label="Bruto pensioen vanuit werkgever(s) en AOW per jaar"
        v-if="modelValue.inkomenType == 'Pensioen'"
      />
    </div>
    <template v-if="modelValue.inkomenType !== 'Anders'">
      <div class="flex-container flex-grow">
        <customInput
          v-model="modelValue.beroep"
          type="text"
          :label="
            modelValue.inkomenType == 'Pensioen' ||
            modelValue.inkomenType == 'Uitkering' ||
            modelValue.inkomenType == 'Werkzoekende' ||
            modelValue.inkomenType == 'Geen'
              ? 'Voormalig beroep'
              : 'Beroep'
          "
        />
        <customInput
          v-model="modelValue.bedrijf"
          type="text" label="Naam bedrijf"
        />
      </div>
      <div
        v-if="modelValue.inkomenType !== 'Eenmanszaak' && modelValue.inkomenType !== 'Zelfstandige'"
        class="flex-container flex-grow"
      >
        <customInput
          v-model="modelValue.arbeidsSituatie" type="dropdown"
          :label="
            notWorking
              ? `Wat was ${index === 0 ? 'uw' : 'deze persoon zijn'} arbeidssituatie?`
              : `Wat is ${index === 0 ? 'uw' : 'deze persoon zijn'} arbeidssituatie?`
          "
          :options="dynamicOptionsForWorkSituation"
        />
        <customInput
          v-if="modelValue.arbeidsSituatie === 'Anders'"
          v-model="modelValue.arbeidsSituatieAnders"
          type="text"
          :label="`Omschrijf
            ${
              notWorking
                ? `${
                  index === 0
                    ? 'wat jouw arbeidssituatie was'
                    : 'deze persoon zijn arbeidssituatie was'
                  }`
                : `${
                  index === 0
                    ? 'wat jouw arbeidssituatie is'
                    : 'deze persoon zijn arbeidssituatie is'
                  }`
            }`
          "
        />
      </div>
      <div class="flex-container flex-grow">
        <customInput
          v-model="modelValue.branche" type="dropdown"
          :label="
            notWorking
              ? `In welke sector was ${index === 0 ? 'u' : 'deze persoon'} werkzaam?`
              : `In welke sector ${index === 0 ? 'bent u' : 'is deze persoon'} werkzaam?`
          "
          :options="brancheOnlyList"
          @changed="branchSwitched"
        />
      </div>
      <div
        v-if="modelValue.branche && modelValue.branche !== 'anders'"
        style="margin: 20px 0 20px 0"
      >
        <p class="subheader">
          {{
            notWorking
              ? `${index === 0 ? 'Hebt u gewerkt' : 'Heeft deze persoon gewerkt'}`
              : `${index === 0 ? 'Werkt u' : 'Werkt deze persoon'}`
          }}
          in één van deze branches?
        </p>
        <customInput
          v-for="sector in sectorOnlyList"
          v-model="modelValue.sector"
          :key="`${modelValue.branche}-${sector.code}`"
          type="radio2"
          name="radiogroup2" :label="sector.name" :option="sector.code"
        />
      </div>
      <div
        v-if="modelValue.branche === 'anders' || modelValue.sector === 'geen-van-bovenstaande'"
        class="flex-container flex-grow"
      >
        <customInput
          v-if="modelValue.branche === 'anders'"
          v-model="modelValue.brancheAnders"
          type="text"
          :label="`Omschrijf in welke sector
            ${
              notWorking
                ? `${index === 0 ? 'u werkzaam was' : 'deze persoon werkzaam was'}`
                : `${index === 0 ? 'u werkzaam bent' : 'deze persoon werkzaaam is'}`
            }`
          "
        />
        <customInput
          v-model="modelValue.sectorAnders"
          type="text"
          :label="`In welke branche
            ${
              notWorking
                ? `${index === 0 ? 'was u' : 'was deze persoon'}`
                : `${index === 0 ? 'bent u' : 'is deze persoon'}`
            } werkzaam?`
          "
        />
      </div>
    </template>
    <customInput v-else
      v-model="modelValue.inkomenTypeAnders"
      type="text" label="Hoe wordt het inkomen verkregen?"
    />
    <template v-if="modelValue.inkomenType == 'Pensioen'">
      <customInput
        v-model="modelValue.pensioenHeeftAanvullend"
        type="yesno"
        :label="`Heeft ${
          index == 0
            ? 'u'
            : 'deze persoon'
        } ${
          $parent.intake.goalData.type == 'pensioen'
          || $parent.intake.goalData.type == 'levensonderhoud'
            ? `naast deze ${$parent.intakeAdmin.beleggen.brand} rekening nog ander`
            : 'een'
        } aanvullend pensioen (lijfrentes/koopsommen/banksparen)?`"
      />
      <customInput v-if="modelValue.pensioenHeeftAanvullend == 'Yes'"
        v-model="modelValue.pensioenAanvullend"
        type="money"
        label="Schatting aanvullend pensioen (lijfrentes/koopsommen/banksparen) per jaar"
        class="double-line-label"
      />
      <customInput
        v-model="modelValue.persioenBeheer"
        type="yesno" :label="
          index == 0
            ? 'Heeft u een deel van uw pensioen in eigen beheer?'
            : 'Heeft deze persoon een deel van het pensioen in eigen beheer?'
        "
      />
      <div class="flex-container flex-grow" v-if="modelValue.persioenBeheer == 'Yes'">
        <customInput v-if="modelValue.persioenBeheer == 'Yes'"
          v-model="modelValue.pensioenBeheerBV"
          type="text" label="Bij welke BV?"
        />
        <customInput
          v-model="modelValue.pensioenBeheerKVK"
          type="text" label="KVK-nummer"
        />
      </div>
      <div class="row" v-if="modelValue.persioenBeheer == 'Yes'">
        <customInput
          v-model="modelValue.companyFiles"
          type="file"
          :prefix="`pensioenbv${index}`"
          :validation="['files']"
        />
        <div class="msg">
          <ul style="padding-left:13px; margin:0px;">
            <li>Graag uw jaarrekening van de BV uploaden.</li>
            <li>Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.</li>
          </ul>
        </div>
      </div>
    </template>

    <customInput
      v-model="modelValue.anderInkomen"
      type="yesno" :label="
        index == 0
          ? 'Heeft u nog inkomsten uit andere bronnen exclusief verhuur van vastgoed?'
          : 'Heeft deze persoon nog inkomsten uit andere bronnen exclusief verhuur van vastgoed?'
      "
    />
    <div class="flex-container flex-grow" v-if="modelValue.anderInkomen == 'Yes'">
      <customInput
        v-model="modelValue.anderInkomenType"
        type="dropdown" label="Inkomen type"
        :options="[
          {label:'Sparen', value:'Sparen'},
          {label:'Beleggen', value:'Beleggen'},
          {label:'Verhuur (overig)', value:'Verhuur'},
          {label:'Anders', value:'Anders'},
        ]"
      />
      <customInput
        v-if="modelValue.anderInkomenType == 'Anders'"
        v-model="modelValue.anderInkomenTypeOmschrijving"
        type="text" label="Inkomen type omschrijving"
      />
      <customInput
        v-model="modelValue.anderInkomenPerJaar"
        type="money" label="Bedrag per jaar"
      />
    </div>
    <customInput
      v-model="modelValue.insider"
      type="yesno" :label="`${
        index == 0
          ? 'Valt u onder'
          : 'Valt deze persoon onder'
        } een ‘insider’ regeling bij een effecten-uitgevende instelling
        en/of in de financiële sector?`
      "
    />
    <div class="row" v-if="modelValue.insider == 'Yes'">
      <customInput
        v-model="modelValue.financeFiles"
        type="file" :prefix="`insider${index}`" :validation="['files']"
      />
      <div class="msg"><ul style="padding-left:13px; margin:0px;">
        <li>Graag uw insidersdocument uploaden.</li>
        <li>Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.</li>
      </ul></div>
    </div>

    <template v-if="modelValue.inkomenType != 'Pensioen'">
      <p class="subheader">Verwacht pensioen</p>
      <customInput
        v-model="modelValue.pensioenToereikend"
        type="yesno" :label="
          index == 0
            ? 'Is uw verwachte pensioen toereikend?'
            : 'Is het verwachte pensioen voor deze persoon toereikend?'
        "
      />
      <customInput
        v-if="
          $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
        "
        v-model="modelValue.pensioen"
        type="money" label="Bruto pensioen vanuit werkgever(s) en AOW per jaar"
      />
      <customInput
        v-model="modelValue.pensioenHeeftAanvullend"
        type="yesno" :label="`Heeft ${
          index == 0
            ? 'u'
            : 'deze persoon'
          } een aanvullend pensioen ${
            $parent.intake.goalData.type == 'pensioen'
            || $parent.intake.goalData.type == 'levensonderhoud'
              ? 'naast deze rekening'
              : ''
          } (lijfrentes/koopsommen/banksparen)?`
        "
      />
      <customInput v-if="modelValue.pensioenHeeftAanvullend == 'Yes'"
        v-model="modelValue.pensioenAanvullend" type="money"
        label="Schatting aanvullend pensioen (lijfrentes/koopsommen/banksparen) per jaar"
        :validation="['notrequired']" class="double-line-label"
      />

      <template v-if="
        $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
        && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
      ">
        <customInput
          v-model="modelValue.persioenBeheer"
          type="yesno" :label="
            index == 0
              ? 'Heeft u een deel van uw pensioen in eigen beheer?'
              : 'Heeft deze persoon een deel van het pensioen in eigen beheer?'
          "
        />
        <div class="flex-container flex-grow" v-if="modelValue.persioenBeheer == 'Yes'">
          <customInput
            v-model="modelValue.pensioenBeheerBV" type="text"
            label="Bij welke BV?"
          />
          <customInput
            v-model="modelValue.pensioenBeheerKVK" type="text"
            label="KVK-nummer"
          />
        </div>
        <div class="row" v-if="modelValue.persioenBeheer == 'Yes'">
          <customInput
            v-model="modelValue.companyFiles"
            type="file"
            :prefix="`pensioenbv${index}`"
            :validation="['files']"
          />
          <div class="msg">
            <ul style="padding-left:13px; margin:0px;">
              <li>Graag uw jaarrekening van de BV uploaden.</li>
              <li>Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.</li>
            </ul>
          </div>
        </div>
      </template>
    </template>

    <template v-if="goalType === 'uitkerend'">
      <p class="subheader" v-if="index==0">
        Zijn uw inkomsten zonder deze {{ $parent.intakeAdmin.beleggen.brand }} rekening voldoende
        voor uw vaste uitgavenpatroon?
      </p>
      <p class="subheader" v-else>
        Heeft deze persoon zonder deze {{ $parent.intakeAdmin.beleggen.brand }} rekenening voldoende
        inkomsten voor zijn/haar vaste uitgavenpatroon?
      </p>
    </template>
    <template v-else>
      <p class="subheader" v-if="index==0">
        Zijn uw inkomsten voldoende om in uw levensonderhoud te voorzien?
      </p>
      <p class="subheader" v-else>
        Heeft deze persoon voldoende inkomsten om in zijn/haar levensonderhoud te voorzien?
      </p>
    </template>
    <customInput
      v-if="
        ($parent.intakeAdmin.beleggen.brand === 'VMVB'
        || $parent.intakeAdmin.beleggen.brand === 'BVS')
        && index !== 0
      "
      v-model="modelValue.gezamenlijkLevensonderhoud"
      type="yesno"
      label="Is deze vraag al bij een ander persoon beantwoord?"
    />
    <template
      v-if="
        index == 0
        || $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
        || $parent.intakeAdmin.beleggen.brand === 'OXBY'
        || modelValue.gezamenlijkLevensonderhoud === 'No'
      "
    >
      <customInput
        v-model="modelValue.levensonderhoud" type="radio2"
        name="radiogroup1" option="ja, en kan sparen"
        :label="`Ja, en ${index == 0 ? 'ik' : 'hij/zij'} kan sparen`"
      />
      <customInput
        v-if="modelValue.levensonderhoud == 'ja, en kan sparen'"
        v-model="modelValue.kanSparenBedrag" type="money"
        label="Bedrag per maand"
      />
      <customInput
        v-model="modelValue.levensonderhoud" type="radio2"
        name="radiogroup1" label="Ja, voldoende" option="ja, voldoende"
      />
      <customInput
        v-model="modelValue.levensonderhoud"
        type="radio2"
        name="radiogroup1"
        :label="`Nee, er is geld nodig uit deze ${$parent.intakeAdmin.beleggen.brand} rekening`"
        option="nee, vanuit deze rekening"
      />
      <customInput
        v-if="modelValue.levensonderhoud == 'nee, vanuit deze rekening'"
        v-model="modelValue.levensonderhoudBedragPerJaar" type="money"
        label="Bedrag per jaar"
      />
      <customInput
        v-if="goalType === 'opbouwend'"
        v-model="modelValue.levensonderhoud" type="radio2"
        name="radiogroup1" label="Nee, er is geld nodig vanuit een andere rekening"
        option="nee, vanuit andere rekening"
      />
      <div
        v-if="
          goalType === 'uitkerend'
          && (
            modelValue.levensonderhoud === 'ja, en kan sparen'
            || modelValue.levensonderhoud === 'ja, voldoende'
          )
        "
      >
        <div class="msg" style="margin-top: 20px">
          U geeft aan dat {{ index == 0 ? 'u' : 'deze persoon' }} zonder dit variabele inkomen bij
          {{ $parent.intakeAdmin.beleggen.brand }} voldoende inkomsten heeft voor
          {{ index == 0 ? 'uw' : 'deze persoon zijn/haar' }} vaste uitgavenpatroon.
        </div>
        <p class="subheader">
          {{
            index == 0
              ? `Als de inkomsten van deze ${$parent.intakeAdmin.beleggen.brand} rekening lager
                worden of wegvallen, dan hoef ik mijn manier van leven niet aan te passen.`
              : `Als de inkomsten van deze persoon zijn/haar ${$parent.intakeAdmin.beleggen.brand}
                rekening lager worden of wegvallen, dan hoeft deze persoon zijn/haar manier van
                leven niet aan te passen.`
          }}
        </p>
        <customInput
          v-model="modelValue.manierVanLeven"
          type="radio2"
          name="radiogroup3"
          label="Eens"
          option="Yes"
        />
        <customInput
          v-model="modelValue.manierVanLeven"
          type="radio2"
          name="radiogroup3"
          label="Oneens"
          option="No"
        />
      </div>
      <div
        v-else-if="
          goalType === 'uitkerend'
          && modelValue.levensonderhoud === 'nee, vanuit deze rekening'
        "
      >
        <div class="msg" style="margin-top: 20px">
          U geeft aan dat {{ index == 0 ? 'u' : 'deze persoon' }} zonder dit variabele inkomen bij
          {{ $parent.intakeAdmin.beleggen.brand }} NIET voldoende inkomsten heeft voor
          {{ index == 0 ? 'uw' : 'deze persoon zijn/haar' }} vaste uitgavenpatroon en dat de
          inkomsten hiervan daarvoor nodig zijn.
        </div>
        <p class="subheader">
          {{
            index == 0
            ? `Als de inkomsten van deze ${$parent.intakeAdmin.beleggen.brand} rekening lager
              worden of wegvallen, kan ik mijn manier van leven aanpassen zodat ik wél voldoende
              inkomsten heb.`
              : `Als de inkomsten van deze ${$parent.intakeAdmin.beleggen.brand} rekening lager
              worden of wegvallen, kan deze persoon zijn/haar manier van leven aanpassen zodat
              deze persoon wél voldoende inkomsten heeft.`
          }}
        </p>
        <customInput
          v-model="modelValue.manierVanLeven"
          type="radio2"
          name="radiogroup4"
          label="Eens"
          option="Yes"
        />
        <customInput
          v-model="modelValue.manierVanLeven"
          type="radio2"
          name="radiogroup4"
          label="Oneens"
          option="No"
        />
      </div>
    </template>

    <template v-if="$parent.intake.goalData.box !== '1'">
      <p class="subheader">Herkomst startvermogen</p>
      <div class="flex-container flex-grow">
        <ul style="list-style-type: none; margin:0; padding: 0;">
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenSalaris"
              type="yesno2"
              label="Sparen / beleggen uit salaris"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenErfenis"
              type="yesno2"
              label="Erfenis"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenSchenking"
              type="yesno2"
              label="Schenking"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenWoningverkoop"
              type="yesno2"
              label="Woningverkoop"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <div
            v-if="modelValue.herkomstVermogenWoningverkoop === 'Yes'"
            class="flex-container flex-grow"
          >
            <customInput
              type="text"
              v-model="modelValue.woningVerkoopPostcode"
              label="Postcode (verkochte woning)"
              placeholder="1111AA"
            />
            <customInput
              type="text"
              v-model="modelValue.woningVerkoopHuisnummer"
              label="Huisnummer"
            />
            <customInput
              type="text"
              v-model="modelValue.woningVerkoopToevoeging"
              label="Toevoeging"
              :validation="['notrequired']"
            />
          </div>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenBedrijfsverkoop"
              type="yesno2"
              label="Bedrijfsverkoop"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenBox1lijfrente"
              type="yesno2"
              label="Box 1-lijfrente"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenBox3lijfrente"
              type="yesno2"
              label="Box 3-lijfrente"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenGoudenhanddruk"
              type="yesno2"
              label="Gouden handdruk"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenCryptovaluta"
              type="yesno2"
              label="Cryptovaluta"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <li>
            <customInput
              v-model="modelValue.herkomstVermogenAnders"
              type="yesno2"
              label="Anders"
              boxtype="checkbox"
              :validation="[$parent.checkAssetOrigin(modelValue) ? 'notrequired' : 'yes']"
              :watch="$parent.checkAssetOrigin(modelValue)"
            />
          </li>
          <customInput v-if="modelValue.herkomstVermogenAnders === 'Yes'"
            v-model="modelValue.herkomstVermogenOmschrijving"
            type="text" label="Herkomst omschrijving"
          />
        </ul>
      </div>
    </template>

    <p class="subheader">Bezittingen</p>
    <div v-if="index!=0" class="msg">
      Zijn uw bezittingen al eerder opgegeven bij een ander persoon? Beantwoord de vragen
      dan met <b>Nee</b>.
    </div>

    <customInput
      v-if="index != 0"
      v-model="modelValue.spaarrekening"
      type="yesno"
      :label="
        index == 0
          ? 'Heeft u naast het startvermogen nog vermogen op een betaal- of spaarrekening?'
          : 'Bezit deze persoon een betaal- of spaarrekening?'
      " :validation="['required']"
    />
    <div v-if="modelValue.spaarrekening === 'Yes'" class="flex-container flex-grow">
      <customInput
        v-model="modelValue.spaarrekeningBedrag"
        type="money" label="Geldbedrag op betaal- of spaarrekening"
      />
      <customInput
        :options="$parent.banken" v-model="modelValue.spaarrekeningInstantie"
        type="dropdown" label="Financiële instelling"
      />
    </div>
    <customInput
      v-if="modelValue.spaarrekeningInstantie == 'Anders' && modelValue.spaarrekening === 'Yes'"
      v-model="modelValue.spaarrekeningInstantieOmschrijving"
      type="text" :validation="['required']"
      label="Naam financiële instelling"
    />

    <!-- extra vragen sparen -->
    <template v-if="
      $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
      && $parent.intakeAdmin.beleggen.brand !== 'OXBY'"
    >
      <customInput
        v-if="modelValue.spaarrekening == 'Yes'"
        v-model="modelValue.spaarrekening2"
        type="yesno" :label="
          index == 0
          ? 'Heeft u nog een betaal- of spaarrekening?'
          : 'Bezit deze persoon nog een betaal- of spaarrekening?'
        "
      />
      <template v-if="modelValue.spaarrekening2 == 'Yes'">
        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.spaarrekeningBedrag2"
            type="money" label="Bedrag"
          />
          <customInput
            :options="$parent.banken"
            v-model="modelValue.spaarrekeningInstantie2"
            type="dropdown" label="Financiële instelling"
          />
        </div>
        <customInput
          v-if="modelValue.spaarrekeningInstantie2 === 'Anders'"
          v-model="modelValue.spaarrekeningInstantie2Omschrijving"
          type="text" label="Naam financiële instelling"
          :validation="['required']"
        />
        <customInput
          v-if="modelValue.spaarrekening2 == 'Yes'"
          v-model="modelValue.spaarrekening3"
          type="yesno" :label="
            index == 0
              ? 'Heeft u nog een betaal- of spaarrekening?'
              : 'Bezit deze persoon nog een betaal- of spaarrekening?'
          "
        />
        <template v-if="modelValue.spaarrekening3 == 'Yes'">
          <div class="flex-container flex-grow">
            <customInput
              v-model="modelValue.spaarrekeningBedrag3"
              type="money" label="Bedrag"
            />
            <customInput
              :options="$parent.banken"
              v-model="modelValue.spaarrekeningInstantie3"
              type="dropdown" label="Financiële instelling"
            />
          </div>
          <customInput
            v-if="modelValue.spaarrekeningInstantie3 == 'Anders'"
            v-model="modelValue.spaarrekeningInstantie3Omschrijving"
            type="text" label="Naam Financiële instelling"
            :validation="['required']"
          />
        </template>
      </template>
    </template>

    <customInput
      v-model="modelValue.beleggingen"
      type="yesno" :label="
        index == 0
          ? 'Heeft u verder beleggingen?'
          : 'Bezit deze persoon verder nog beleggingen?'
      " :validation="['required']"
    />

    <template v-if="modelValue.beleggingen == 'Yes'">
      <div class="flex-container flex-grow">
        <customInput
          v-model="modelValue.beleggingenTypeDienst"
          type="dropdown" label="Type dienst"
          :options="beleggingsDienstTypes"
        />
        <customInput
          v-model="modelValue.beleggingenBedrag"
          type="money" label="Bedrag"
        />
      </div>
      <div v-if="modelValue.beleggingenTypeDienst !== 'Lening'">
        <div class="flex-container flex-grow">
          <customInput
            v-model="modelValue.beleggingenProfiel"
            type="dropdown" label="Profiel"
            :options="$parent.beleggingsProfielen"
          />
          <customInput
            v-model="modelValue.beleggingenInstantie"
            type="dropdown" label="Financiële instelling"
            :options="$parent.beleggingsInstanties"
          />
        </div>
        <customInput
          v-if="modelValue.beleggingenInstantie == 'Anders'"
          v-model="modelValue.beleggingenInstantieOmschrijving"
          type="text" label="Naam financiële instelling"
          :validation="['required']"
        />
      </div>
      <!-- extra vragen beleggen -->
      <template v-if="
        $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
        && $parent.intakeAdmin.beleggen.brand !== 'OXBY'"
      >
        <customInput
          v-model="modelValue.beleggingenMeer"
          type="yesno" :label="
            index == 0
              ? 'Heeft u meer beleggingen?'
              : 'Bezit deze persoon meer beleggingen?'
          "
        />
        <template v-if="modelValue.beleggingenMeer == 'Yes'">
          <div class="flex-container flex-grow">
            <customInput
              v-model="modelValue.beleggingenMeerTypeDienst"
              type="dropdown" label="Type dienst"
              :options="beleggingsDienstTypes"
            />
            <customInput
              v-model="modelValue.beleggingenMeerBedrag"
              type="money" label="Bedrag"
            />
          </div>
          <div v-if="modelValue.beleggingenMeerTypeDienst !== 'Lening'">
            <div class="flex-container flex-grow">
              <customInput
                v-model="modelValue.beleggingenMeerProfiel"
                type="dropdown" label="Profiel"
                :options="$parent.beleggingsProfielen"
              />
              <customInput
                v-model="modelValue.beleggingenMeerInstantie"
                type="dropdown"
                label="Financiële instelling"
                :options="$parent.beleggingsInstanties"
              />
            </div>
            <customInput
              v-if="modelValue.beleggingenMeerInstantie == 'Anders'"
              v-model="modelValue.beleggingenMeerInstantieOmschrijving"
              type="text" label="Naam financiële instelling"
              :validation="['required']"
            />
          </div>
          <customInput
            v-model="modelValue.beleggingenNogMeer"
            type="yesno" :label="
              index == 0
                ? 'Heeft u nog meer beleggingen?'
                : 'Bezit deze persoon nog meer beleggingen?'
            "
          />
          <template v-if="modelValue.beleggingenNogMeer == 'Yes'">
            <div class="flex-container flex-grow">
              <customInput
                v-model="modelValue.beleggingenNogMeerTypeDienst"
                type="dropdown" label="Type dienst"
                :options="beleggingsDienstTypes"
              />
              <customInput
                v-model="modelValue.beleggingenNogMeerBedrag"
                type="money" label="Bedrag"
              />
            </div>
            <div v-if="modelValue.beleggingenNogMeerTypeDienst !== 'Lening'">
              <div class="flex-container flex-grow">
                <customInput
                  v-model="modelValue.beleggingenNogMeerProfiel"
                  type="dropdown" label="Profiel"
                  :options="$parent.beleggingsProfielen"
                />
                <customInput
                  v-model="modelValue.beleggingenNogMeerInstantie"
                  type="dropdown"
                  label="Financiële instelling"
                  :options="$parent.beleggingsInstanties"
                />
              </div>
              <customInput
                v-if="modelValue.beleggingenNogMeerInstantie == 'Anders'"
                v-model="modelValue.beleggingenNogMeerInstantieOmschrijving"
                type="text" label="Naam financiële instelling"
                :validation="['required']"
              />
            </div>
          </template>
        </template>
      </template>
      <customInput
        v-if="modelValue.beleggingen == 'Yes' && modelValue.beleggingenBedrag > 1000000"
        v-model="modelValue.beleggingenBelang" type="yesno"
        label="Heeft u meer dan 1% belang bij een beursgenoteerd bedrijf?"
      />
    </template>

    <customInput
      v-model="modelValue.eigenwoning"
      @changed="clearRentData"
      type="yesno"
      :label=" index == 0
        ? 'Heeft u een eigen woning?'
        : 'Bezit deze persoon een eigen woning?'
      "
      :validation="['required']"
    />
    <customInput
      v-if="modelValue.eigenwoning == 'Yes'"
      v-model="modelValue.eigenwoningVrijeverkoopwaarde"
      type="money" label="Vrije verkoopwaarde eigen woning"
    />
    <customInput
      v-model="modelValue.onroerendgoed"
      type="yesno" :label="
        index == 0
          ? 'Heeft u overig onroerend goed?'
          : 'Bezit deze persoon overig onroerend goed?'
      " :validation="['required']"
    />
    <customInput
      v-if="modelValue.onroerendgoed == 'Yes'"
      v-model="modelValue.onroerendgoedCommercieel"
      type="yesno"
      label="Wordt dit (deels) voor commerciële doeleinden gebruikt zoals bijvoorbeeld verhuur,
        maar niet voor eigen gebruik?"
    />
    <p class="msg" v-if="modelValue.onroerendgoed == 'Yes'">
      Onder <strong>eigen gebruik</strong> wordt verstaan:
      {{
        $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
        || $parent.intakeAdmin.beleggen.brand === 'OXBY'
          ? 'eigen bedrijfspanden in BV, '
          : ''
      }}woning (of vakantiewoning) voor eigen gebruik, appartement voor studerende kinderen etc.
    </p>
    <div class="flex-container flex-grow">
      <customInput
        v-if="modelValue.onroerendgoed === 'Yes'"
        v-model="modelValue.onroerendgoedVrijeverkoopwaarde"
        type="money" label="Totale vrije verkoopwaarde overig onroerend goed"
      />
      <customInput
        v-if="modelValue.onroerendgoed === 'Yes' && modelValue.onroerendgoedCommercieel === 'Yes'"
        v-model="modelValue.onroerendgoedBedragPerJaar"
        type="money"
        label="Inkomen per jaar overig onroerend goed"
      />
    </div>
    <div class="flex-container flex-grow">
      <customInput
        v-if="modelValue.onroerendgoed === 'Yes' && modelValue.onroerendgoedCommercieel === 'Yes'"
        v-model="modelValue.onroerendgoedObjecten"
        type="number"
        label="Hoeveel objecten bezit u voor commerciële doeleinden?"
      />
    </div>

    <div class="subheader"
      v-if="modelValue.eigenwoning == 'Yes' || modelValue.onroerendgoed == 'Yes'"
    >
      Hypotheek
    </div>

    <template v-if="modelValue.eigenwoning == 'Yes'">
      <!-- hypotheek eigen woning 1 -->
      <customInput
        v-model="modelValue.hypotheekEigenWoning"
        type="yesno" label="Zit er een hypotheek op de eigen woning?"
      />
      <div
        v-if="modelValue.hypotheekEigenWoning == 'Yes'"
        class="flex-container flex-grow"
      >
        <customInput
          v-model="modelValue.hypotheekEigenWoningType"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekEigenWoningWaarde"
          :validation="['min']" :min="1" type="money" label="Waarde"
        />
        <template
          v-if="
            $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
          "
        >
          <customInput
            :options="$parent.hypotheekInstanties"
            v-model="modelValue.hypotheekEigenWoningInstantie"
            type="dropdown"
            label="Hypotheek verstrekker"
          />
          <customInput
            v-if="modelValue.hypotheekEigenWoningInstantie === 'Anders'"
            v-model="modelValue.hypotheekEigenWoningInstantieOmschrijving"
            type="text"
            label="Naam verstrekker"
            :validation="['required']"
          />
        </template>
        <customInput
          v-model="modelValue.hypotheekEigenWoningRenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekEigenWoningRenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekEigenWoningRente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekEigenWoningLooptijd"
            type="date" label="Einddatum rentevaste periode" :validation="['min']"
            :minDatetime="new Date()" class="flex-grow-double"
          />
        </template>
      </div>

      <!-- hypotheek eigen woning 2 -->
      <customInput
        v-if="modelValue.hypotheekEigenWoning == 'Yes'"
        v-model="modelValue.hypotheekEigenWoning2"
        type="yesno" label="Zit er nog een hypotheek op de eigen woning?"
      />
      <div
        v-if="modelValue.hypotheekEigenWoning2 == 'Yes'"
        class="flex-container flex-grow"
      >
        <customInput
          v-model="modelValue.hypotheekEigenWoning2Type"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekEigenWoning2Waarde"
          :validation="['min']" :min="1" type="money" label="Waarde"
        />
        <template
          v-if="
            $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
          "
        >
          <customInput
            :options="$parent.hypotheekInstanties"
            v-model="modelValue.hypotheekEigenWoning2Instantie"
            type="dropdown"
            label="Hypotheek verstrekker"
          />
          <customInput
            v-if="modelValue.hypotheekEigenWoning2Instantie === 'Anders'"
            v-model="modelValue.hypotheekEigenWoning2InstantieOmschrijving"
            type="text"
            label="Naam verstrekker"
            :validation="['required']"
          />
        </template>
        <customInput
          v-model="modelValue.hypotheekEigenWoning2RenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekEigenWoning2RenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekEigenWoning2Rente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekEigenWoning2Looptijd"
            type="date" label="Einddatum rentevaste periode" :validation="['min']"
            :minDatetime="new Date()" class="flex-grow-double"
          />
        </template>
      </div>

      <!-- hypotheek eigen woning 3-->
      <customInput
        v-if="modelValue.hypotheekEigenWoning2 == 'Yes'"
        v-model="modelValue.hypotheekEigenWoning3"
        type="yesno" label="Zit er nog een hypotheek op de eigen woning?"
      />
      <div
        v-if="modelValue.hypotheekEigenWoning3 == 'Yes'"
        class="flex-container flex-grow"
      >
        <customInput
          v-model="modelValue.hypotheekEigenWoning3Type"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekEigenWoning3Waarde"
          :validation="['min']" :min="1" type="money" label="Waarde"
        />
        <template
          v-if="
            $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
          "
        >
          <customInput
            :options="$parent.hypotheekInstanties"
            v-model="modelValue.hypotheekEigenWoning3Instantie"
            type="dropdown"
            label="Hypotheek verstrekker"
          />
          <customInput
            v-if="modelValue.hypotheekEigenWoning3Instantie === 'Anders'"
            v-model="modelValue.hypotheekEigenWoning3InstantieOmschrijving"
            type="text"
            label="Naam verstrekker"
            :validation="['required']"
          />
        </template>
        <customInput
          v-model="modelValue.hypotheekEigenWoning3RenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekEigenWoning3RenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekEigenWoning3Rente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekEigenWoning3Looptijd"
            type="date" label="Einddatum rentevaste periode" :validation="['min']"
            :minDatetime="new Date()" class="flex-grow-double"
          />
        </template>
      </div>
    </template>

    <template v-if="modelValue.onroerendgoed == 'Yes'">
      <!-- deel onroerend goed 1-->
      <customInput
        v-model="modelValue.hypotheekOnroerendGoed"
        type="yesno" label="Zit er een hypotheek op het overig onroerend goed?"
      />
      <div class="flex-container flex-grow" v-if="modelValue.hypotheekOnroerendGoed == 'Yes'">
        <customInput
          v-model="modelValue.hypotheekOnroerendGoedType"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoedWaarde"
          type="money" label="Waarde"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoedRenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekOnroerendGoedRenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekOnroerendGoedRente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekOnroerendGoedLooptijd"
            :minDatetime="new Date()" :validation="['min']" type="date"
            label="Einddatum rentevaste periode" class="flex-grow-double"
          />
        </template>
      </div>

      <!-- deel onroerend goed 2-->
      <customInput
        v-if="modelValue.hypotheekOnroerendGoed == 'Yes'"
        v-model="modelValue.hypotheekOnroerendGoed2"
        type="yesno" label="Zit er nog een hypotheek op het overig onroerend goed?"
      />
      <div class="flex-container flex-grow" v-if="modelValue.hypotheekOnroerendGoed2 == 'Yes'">
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed2Type"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed2Waarde"
          type="money" label="Waarde"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed2RenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekOnroerendGoed2RenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekOnroerendGoed2Rente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekOnroerendGoed2Looptijd"
            :minDatetime="new Date()" :validation="['min']"
            type="date" label="Einddatum rentevaste periode" class="flex-grow-double"
          />
        </template>
      </div>

      <!-- deel onroerend goed 3 -->
      <customInput
        v-if="modelValue.hypotheekOnroerendGoed2 == 'Yes'"
        v-model="modelValue.hypotheekOnroerendGoed3"
        type="yesno" label="Zit er nog een hypotheek op het overig onroerend goed?"
      />
      <div class="flex-container flex-grow" v-if="modelValue.hypotheekOnroerendGoed3 == 'Yes'">
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed3Type"
          type="dropdown" label="Type" :options="[
            {label:'Annuitair', value:'annuitair'},
            {label:'Lineair', value:'lineair'},
            {label:'Aflossingsvrij', value:'aflossingsvrij'},
            {label:'Spaarhypotheek', value:'spaarhypotheek'},
          ]"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed3Waarde"
          type="money" label="Waarde"
        />
        <customInput
          v-model="modelValue.hypotheekOnroerendGoed3RenteType"
          type="dropdown" label="Rente Type" :options="[
            {label:'Vast', value:'vast'},
            {label:'Variabel', value:'variabel'},
          ]"
        />
        <template v-if="modelValue.hypotheekOnroerendGoed3RenteType == 'vast'">
          <customInput
            placeholder="Max. 15%"
            v-model="modelValue.hypotheekOnroerendGoed3Rente"
            type="percentage"
            label="Rentepercentage"
            :max="1500"
            :validation="['max']"
          />
          <customInput
            v-model="modelValue.hypotheekOnroerendGoed3Looptijd"
            :minDatetime="new Date()" :validation="['min']"
            type="date" label="Einddatum rentevaste periode" class="flex-grow-double"
          />
        </template>
      </div>
    </template>

    <div class="subheader">Verplichtingen</div>
    <div v-if="index!=0" class="msg">
      Zijn uw verplichtingen al eerder opgegeven bij een ander persoon?
      Beantwoord de vragen dan met <b>Nee</b>.
    </div>
    <customInput
      v-if="modelValue.eigenwoning == 'No'"
      v-model="modelValue.huur"
      type="yesno"
      :label="`Heeft ${index == 0 ? 'u' : 'deze persoon'} huurlasten?`"
    />
    <customInput
      v-if="modelValue.huur == 'Yes'"
      v-model="modelValue.huurlasten" type="money"
      label="Huurlasten per maand"
    />
    <customInput
      key="geenwoninggeenhuur"
      v-if="
        modelValue.eigenwoning == 'No'
        && modelValue.huur == 'No'
        && modelValue.zelfdeAdres !== 'Yes'
      "
      v-model="modelValue.geenWoningGeenHuurlasten"
      type="text"
      label="U heeft geen huurlasten en geen eigen woning, kunt u uw woonsituatie toelichten."
    />
    <!-- schuld 1 -->
    <customInput
      v-model="modelValue.schulden" type="yesno"
      :label="`Heeft ${index == 0 ? 'u' : 'deze persoon'} verdere verplichtingen?`"
    />
    <div class="flex-container flex-grow" v-if="modelValue.schulden == 'Yes'">
      <customInput
        v-model="modelValue.schuldenType" type="dropdown"
        label="Type" class="listup" :options="[
          {label:'Persoonlijke lening', value:'persoonlijkelening'},
          {label:'Studieschuld', value:'studieschuld'},
          {label:'Alimentatie', value:'alimentatie'},
          {label:'Anders', value:'anders'},
        ]"
      />
      <customInput
        v-if="modelValue.schuldenType != 'alimentatie'"
        v-model="modelValue.schuldenBedrag" type="money"
        label="Totaal bedrag"
      />
      <customInput
        v-model="modelValue.schuldenMaandelijks" type="money"
        label="Verplichting per maand"
      />
    </div>

    <template v-if="
      $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
      && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
      && modelValue.schulden == 'Yes'"
    >
      <!-- schuld 2 -->
      <customInput
        v-model="modelValue.schuldenMeer" type="yesno"
        :label="`Heeft ${index == 0 ? 'u' : 'deze persoon'} meer verplichtingen?`"
      />
      <div class="flex-container flex-grow" v-if="modelValue.schuldenMeer == 'Yes'">
        <customInput
          v-model="modelValue.schuldenMeerType"
          type="dropdown" label="Type" class="listup" :options="[
            {label:'Persoonlijke lening', value:'persoonlijkelening'},
            {label:'Studieschuld', value:'studieschuld'},
            {label:'Alimentatie', value:'alimentatie'},
            {label:'Anders', value:'anders'},
          ]"
        />
        <customInput
          v-if="modelValue.schuldenMeerType != 'alimentatie'"
          v-model="modelValue.schuldenMeerBedrag"
          type="money" label="Totaal bedrag"
        />
        <customInput
          v-model="modelValue.schuldenMeerMaandelijks"
          type="money" label="Verplichting per maand"
        />
      </div>

      <!-- schuld 3 -->
      <customInput
        v-if="modelValue.schuldenMeer == 'Yes'"
        v-model="modelValue.schuldenMeer2" type="yesno"
        :label="`Heeft ${index == 0 ? 'u' : 'deze persoon'} nog meer verplichtingen?`"
      />
      <div class="flex-container flex-grow" v-if="modelValue.schuldenMeer2 == 'Yes'">
        <customInput
          v-model="modelValue.schuldenMeer2Type" type="dropdown"
          label="Type" class="listup" :options="[
            {label:'Persoonlijke lening', value:'persoonlijkelening'},
            {label:'Studieschuld', value:'studieschuld'},
            {label:'Alimentatie', value:'alimentatie'},
            {label:'Anders', value:'anders'},
          ]"
        />
        <customInput
          v-if="modelValue.schuldenMeer2Type != 'alimentatie'"
          v-model="modelValue.schuldenMeer2Bedrag" type="money"
          label="Totaal bedrag"
        />
        <customInput
          v-model="modelValue.schuldenMeer2Maandelijks" type="money"
          label="Verplichting per maand"
        />
      </div>

      <!-- schuld 4 -->
      <customInput
        v-if="modelValue.schuldenMeer2 == 'Yes'"
        v-model="modelValue.schuldenMeer3" type="yesno"
        :label="`Heeft ${index == 0 ? 'u' : 'deze persoon'} nog meer verplichtingen?`"
      />
      <div class="flex-container flex-grow" v-if="modelValue.schuldenMeer3 == 'Yes'">
        <customInput
          v-model="modelValue.schuldenMeer3Type" type="dropdown"
          label="Type" class="listup" :options="[
            {label:'Persoonlijke lening', value:'persoonlijkelening'},
            {label:'Studieschuld', value:'studieschuld'},
            {label:'Alimentatie', value:'alimentatie'},
            {label:'Anders', value:'anders'},
          ]"
        />
        <customInput
          v-if="modelValue.schuldenMeer3Type != 'alimentatie'"
          v-model="modelValue.schuldenMeer3Bedrag" type="money"
          label="Totaal bedrag"
        />
        <customInput
          v-model="modelValue.schuldenMeer3Maandelijks" type="money"
          label="Verplichting per maand"
        />
      </div>
    </template>

    <template
      v-if="
        (
          $parent.intake.persoonsData[index].land
          && $parent.intake.persoonsData[index].land != 'Nederland'
        )
        || ( modelValue.eigenwoning == 'No' && modelValue.huur == 'Yes')
      "
    >
      <div class="subheader">
        Om uw woonadres vast te kunnen stellen, vragen wij een kopie van een document met daarop
        uw naam en woonadres, bijvoorbeeld een energienota of bankafschrift te uploaden.
      </div>
      <div class="msg">
        <ul style="padding-left:13px; margin:0px;">
          <li>Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.</li>
          <li>
            {{ index == 0 ? 'Uw' : 'Deze persoon zijn'}}
            document mag niet afgeschermd zijn.
          </li>
        </ul>
      </div>
      <customInput
        v-model="modelValue.files"
        type="file"
        :prefix="`inschrijvingsbewijs${Number(index)}`"
        :validation="['files']"
      />
    </template>

  </div>
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'IntakeFinancePage',
  emits: ['update:model-value'],
  data() {
    return {
      adminToggle: false,
    };
  },
  props: {
    modelValue: Object,
    index: Number,
  },
  created() {
    for (let i = 0; i < this.$parent.brancheList.length; i += 1) {
      if (!find(this.$parent.brancheList[i].sectors, { code: 'geen-van-bovenstaande' })) {
        this.$parent.brancheList[i].sectors.push(
          {
            name: 'Geen van bovenstaande',
            code: 'geen-van-bovenstaande',
          },
        );
      }
    }
  },
  computed: {
    goalType() {
      if (
        (
          this.$parent.intake.goalData.type === 'levensonderhoud'
          && this.$parent.intake.goalData.box === '1'
        )
        || this.$parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
        || this.$parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    beleggingsDienstTypes() {
      const servicesArray = [
        { label: 'Advies', value: 'Advies' },
        { label: 'Vermogensbeheer', value: 'Beheer' },
        { label: 'Zelf beleggen', value: 'Zelf' },
      ];
      if (this.$parent.intakeAdmin.beleggen.brand === 'VMVB'
        || this.$parent.intakeAdmin.beleggen.brand === 'BVS') {
        servicesArray.push({ label: 'Uitstaande lening', value: 'Lening' });
      }
      return servicesArray;
    },
    dynamicOptionsForWorkSituation() {
      let optionList = [];
      if (this.modelValue.inkomenType === 'Loondienst') {
        optionList = [
          { label: 'Werknemer', value: 'Werknemer' },
          { label: 'Hoger management', value: 'Hoger management' },
          {
            label: 'Bestuurder',
            value: 'Bestuurder/niet-grootaandeelhouder',
          },
          { label: 'Groot aandeelhouder', value: 'Groot aandeelhouder' },
          { label: 'Anders', value: 'Anders' },
        ];
      } else {
        optionList = [
          { label: 'Werknemer', value: 'Werknemer' },
          { label: 'Hoger management', value: 'Hoger management' },
          {
            label: 'Bestuurder',
            value: 'Bestuurder/niet-grootaandeelhouder',
          },
          { label: 'Groot aandeelhouder', value: 'Groot aandeelhouder' },
          { label: 'Zelfstandige (eenmanszaak)', value: 'Eenmanszaak' },
          { label: 'Zelfstandige (overige)', value: 'Zelfstandige' },
          { label: 'Anders', value: 'Anders' },
        ];
      }
      return optionList;
    },
    notWorking() {
      if (
        this.modelValue.inkomenType === 'Pensioen'
        || this.modelValue.inkomenType === 'Uitkering'
        || this.modelValue.inkomenType === 'Werkzoekende'
        || this.modelValue.inkomenType === 'Geen'
      ) {
        return true;
      }
      return false;
    },
    brancheOnlyList() {
      const brancheOnlyList = [];
      for (let i = 0; i < this.$parent.brancheList.length; i += 1) {
        brancheOnlyList.push(
          {
            label: this.$parent.brancheList[i].branche,
            value: this.$parent.brancheList[i].code,
          },
        );
      }
      brancheOnlyList.push(
        {
          label: 'Anders',
          value: 'anders',
        },
      );
      return brancheOnlyList;
    },
    sectorOnlyList() {
      return find(this.$parent.brancheList, { code: this.modelValue.branche })
        ? find(this.$parent.brancheList, { code: this.modelValue.branche }).sectors
        : [];
    },
    allCountries() {
      return Object.values(this.$parent.allCountries).reduce((obj, key) => {
        obj.push({
          label: key,
          value: key,
        });
        return obj;
      }, []);
    },
  },
  methods: {
    branchSwitched() {
      if (
        this.modelValue.sector
        && !find(this.sectorOnlyList, { code: this.modelValue.sector })
      ) {
        this.modelValue.sector = '';
        this.modelValue.sectorAnders = '';
      }
    },
    setWorkSituation() {
      this.$nextTick(() => {
        if (this.modelValue.inkomenType === 'Eenmanszaak'
        || this.modelValue.inkomenType === 'Zelfstandige') {
          this.modelValue.arbeidsSituatie = 'Groot aandeelhouder';
        }
        if (this.modelValue.inkomenType !== 'Pensioen'
          && this.modelValue.persioenBeheer
          && (
            this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
            || this.$parent.intakeAdmin.beleggen.brand === 'OXBY'
          )
        ) {
          delete this.modelValue.persioenBeheer;
          delete this.modelValue.pensioenBeheerBV;
          delete this.modelValue.pensioenBeheerKVK;
        }
      });
    },
    clearRentData() {
      if (this.modelValue.eigenwoning === 'Yes') {
        delete this.modelValue.huur;
        delete this.modelValue.huurlasten;
        delete this.modelValue.geenWoningGeenHuurlasten;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .double-line-label {
    @media #{$mobile} {
      input[type=money] {
        padding-top: 70px;
      }
      .dropdown-button {
        height: 90px !important;
      }
    }
  }
</style>
